<template>
  <div>
  <LoaderModal :show="isLoading ">
      <template v-slot:body>
        <Loader2/>
      </template>
    </LoaderModal>
    <h2 style="margin-bottom:40px;font-weight: 700;" v-if="props.showTitle">KYC</h2>
    <div class="row">
      <!-- Enroller ID Section -->
      <div class="col-md-12" style="position:relative">
        <ValidatedInput
          name="aadharId"
          label="Aadhaar Number"
          type="text"
          :minlength="12"
          :maxlength="12"
          placeholder="Aadhaar Number"
          v-model="fields.kyc_no"
          :infoMessage="aadhar_message"
          validationType="numbers-only"
          :disabled="fields.aadhaarVerified"
          :success="false"
          :customRules="validateAadharId"
          :successIconOnEnd="fields.aadhaarVerified"
          required
          />
          <!-- :disabled="disableAadharInput" -->
        <button class="btn" v-if="!fields.aadhaarVerified" style="width:fit-content;position: absolute;right: 15px;top: 50px;background-color:transparent;transform: translateY(-60%);text-decoration: underline;text-underline-offset: 4px;" @click="checkAadharId">Generate OTP</button> 
      </div>
    </div>
    <div class="form-group full-width" v-if="!!otpSent">
      <div style="display:flex;justify-content:center;flex-direction:column;" >
        <div id="timer" v-if="timer > 0">Resend OTP in {{timer}} seconds</div>
          <form action="" class="otp-form">
            <input
              v-for="(input, index) in inputs"
              :key="index"
              v-model="inputs[index]"
              maxlength="1"
              type="text"
              @input="handleInput($event, index)"
              @keydown="handleKeydown($event, index)"
              :style="{ borderColor: inputs[index] ? '#00d563 !important' : '#006ea5 !important' }"
              :disabled="inputs[index] === undefined"
            />
          </form>
          <div style="display:flex;justify-content:space-around">
            <button id="resendButton" class="btn btn-invert" @click="resendOTP" :disabled="timer!=0" >Resend OTP</button>
           <button class="btn btn-invert" style="float:left;"  @click="submitOTP">Verify OTP</button>
          </div>
        </div>
    </div>
  </div>
</template>
<script setup>
import { useAadhaar } from '@/composables/useAadhaar';
import ValidatedInput from '../common/CustomInput.vue';
import { showToast } from '@/utils/toaster';
import { useConsultantService } from '@/composables/useDuplicacy';
import { reactive,inject,ref,nextTick,watch,defineExpose } from 'vue';
import Swal from 'sweetalert2';
import { useFormValidation } from '@/composables/userFormValidation';
import LoaderModal from '../common/LoaderModal.vue';
import Loader2 from '../common/Loader-2.vue';
const props = defineProps({
  showTitle:{
    type:Boolean,
    required:false,
    default:true
  }
})
const axios = inject('aadhar_axios'); 

const { otp, generateOtp,submitOtp, aadhar_message,fullName,firstName,lastName,isLoading } = useAadhaar(axios);
const {consultantExistsAadhar} = useConsultantService();
    

// const aadhaarVerified = ref(false);
const disableAadhaarVerifyBtn = ref(false);
const disableAadharInput = ref(false);
const basicInfoAutofilled = ref(false);
const inputs = ref(['', '', '', '','','']);
const otpSent = ref(false);

const fields = reactive({
    addressInfo1:'',
    addressInfo2:'',
    landmark:'',
    pincode:'',
    city:'',
    state:'',
    aadhaar_name:'',
    dob:'',
    gender:'',
    kyc_no:'',
    aadhaarVerified:false
});

const rules = {
  kyc_no: value => (!value ? 'Aadhaar Number is required' : null),
  aadhaarVerified: value => (!value ? 'Please Verify KYC' : null)
};

const timer = ref(45);
let timerVar = null;

const checkAadharId=async()=> {
  if(fields.kyc_no.length == 12 && !otpSent.value){
    await generateOTP();
    disableAadhaarVerifyBtn.value = true; 
    setTimeout(() => {
      disableAadhaarVerifyBtn.value = false; 
    }, 1000);
  }
}
const handleInput = (event, index) => {
    const value = event.target.value;
    if (value) {
      inputs.value[index] = value;
      if (index < inputs.value.length - 1) {
        nextTick(() => {
          const nextInput = document.querySelectorAll('.otp-form input')[index + 1];
          if (nextInput) nextInput.focus();
        });
      }
    }
  };

const validateAadharId=(value)=> {                       
  let invalidAadhaarMsg='Please Enter Valid Aadhaar number';
    if (value.length !== 12) {
      return invalidAadhaarMsg;
      // return 'Aadhaar Number must be exactly 12 digits';
    } 
    return null;
};

const handleKeydown = (event, index) => {
  if (event.key === 'Backspace') {
    if (inputs.value[index] === '') {
      if (index > 0) {
        inputs.value[index - 1] = '';
        nextTick(() => {
          const prevInput = document.querySelectorAll('.otp-form input')[index - 1];
          if (prevInput) prevInput.focus();
        });
      }
    }
  }
};


const handleGenerateOtp = async () => {
      const aadhar_duplicacy_response = await consultantExistsAadhar(fields.kyc_no);
      if(aadhar_duplicacy_response && aadhar_duplicacy_response.result){
        let status = aadhar_duplicacy_response.result.status;
        // let message = aadhar_duplicacy_response.result.statusMessage;
        if(status==1){
            const response = await generateOtp(fields.kyc_no);
            console.log(response);
            if (response && response.success) {
              inputs.value=['', '', '', '','',''];
              timer.value=45;
              disableAadhaarVerifyBtn.value = true;
              startTimer();
              otpSent.value = true;
          }else{
            otpSent.value=false;
            showToast('technicalError');
          }
        }else{
          // let aadharExistsMessage='This Aadhaar Number Already Exists.';
          let aadharExistsMessage='Aadhaar Number is already updated for an existing Advisor';
          aadhar_message.value=aadharExistsMessage;
        }
      }else{
        showToast('technicalError');
      }
    };
const handleSubmitOtp = async () => {
  let kycapprovedMessage ="Aadhaar is successfully verified. KYC approved";
  let invalidOtpMessage ="Please enter correct 6 digit OTP";
  let incorrectOtpMessage ="Please enter correct 6-digit OTP";
  // const concatenatedStr = inputs.value.filter(input => input !== '').join('');
  otp.value =inputs.value.filter(input => input !== '').join('');
  const response = await submitOtp();
  console.log(response);
  if (response && response.data.status=="success_aadhaar") {
  fields.addressInfo1=(response.data.address.house ==''?response.data.address.loc:response.data.address.house+', '+response.data.address.loc);
  fields.addressInfo2=(response.data.address.street==''?response.data.address.po:response.data.address.street+', '+response.data.address.po);
  fields.landmark=response.data.address.landmark;
  fields.pincode=response.data.zip;
  fields.state=response.data.address.state;
  fields.city=response.data.address.dist;
  fields.aadhaar_name = fullName.value;
  fields.dob = response.data.dob;
  fields.gender = response.data.gender;
  // addressInfoAutofilled.value=true;
  aadhar_message.value=kycapprovedMessage;
  fields.aadhaarVerified=true;
  disableAadharInput.value = true;
  basicInfoAutofilled.value=true;
    otpSent.value = false;
  }
  else if(response && response.status_code==422 && !response.success && response.message_code=='verification_failed'){
    aadhar_message.value=incorrectOtpMessage;
    // aadhar_message.value=response.message;
  }
  else if(response && response.status_code==422 && !response.success){
    aadhar_message.value=invalidOtpMessage;
    // aadhar_message.value=response.message;
  }
  else if(response && response.status_code==429 && !response.success){
    aadhar_message.value="Please Try Again";
  }
  else{
  alert('2')
    showToast('technicalError');
  }
};

watch(otpSent, (newValue) => {console.log('otp section changed'+newValue)});
watch(disableAadharInput, (newValue) => {console.log('otp section Disabled'+newValue)});
watch(fields.addressInfo1, (newValue) => {console.log('otp section Disabled'+newValue)});
watch(() => fields.kyc_no, (newVal, oldVal) => {
      // When kyc_no is updated, handle the change
      fields.aadhaarVerified = false; // Reset aadhaar verification status
      disableAadhaarVerifyBtn.value = false; // Enable the Aadhaar Verify button
      aadhar_message.value = ''; // Clear any Aadhaar messages
      otpSent.value=false;
      inputs.value=['', '', '', '','',''];
      // Optionally, you can handle additional logic if kyc_no is empty
      if (newVal === '') {
        console.log('KYC number has been cleared'+oldVal);
        // Perform any other actions when kyc_no is cleared
      }
    });   
const startTimer = () => {
  timerVar = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    } else {
      clearInterval(timerVar);
    }
  }, 1000);
};

const resendOTP=async()=>{await handleGenerateOtp()};
const generateOTP=async ()=>{await handleGenerateOtp()};
const submitOTP=async()=> {await handleSubmitOtp()};


const { isFormValid, errors, validateForm } = useFormValidation(fields, rules);

const getFormData=()=> {
    validateForm();
    if (isFormValid.value) {
      return {
        kyc_no: fields.kyc_no,
        addressInfo1: fields.addressInfo1,
        addressInfo2: fields.addressInfo2,
        city: fields.city,
        state: fields.state,
        landmark: fields.landmark,
        pincode: fields.pincode,
        dob: fields.dob,
        gender: fields.gender,
        aadhaar_name: fullName.value,
        firstName:firstName.value,
        lastName:lastName.value,
      };
    } else {
        const allErrors = [];
      for (const [field, error] of Object.entries(errors.value)) {
      // for (const [error] of Object.entries(errors.value)) {
      if (error) {
        console.log(field)
        allErrors.push(`${error}`);
      }
    }
    console.log(allErrors+'From the basicinfo');
    Swal.fire({
          title: 'Form Errors',
          html: `<div style="text-align: left;display: flex;color: red;flex-direction: column;width: fit-content;justify-content: center;margin: 0 auto;">${allErrors.map(error => `<div><i class="fa fa-circle"></i> ${error}</div>`).join('<br>')}</div>`,
          buttonsStyling: false,
          customClass: {popup: 'custom-swal-popup',confirmButton: "btn btn-primary",icon:'small-icon'},
          confirmButtonText: 'OK'
    });
    return null;
    }
}

defineExpose({ isFormValid,getFormData});
</script>
<style scoped>
.otp-form {
  display: flex;
  justify-content: center;
  gap: 4px;
  input {
    border-radius:10px;
    display: inline-block !important;
    border: 2px solid #006ea5 !important;
    width: 50px !important;
    height: 50px !important;
    text-align: center !important;
  }
}

.full-width {
  margin-top: 20px;
  .input-field {
  width: 100%;
}
}

</style>